export default __webpack_public_path__ + "images/mark-as-resolved-icon.svg";